type i18nLanguage = {
  name: string; // display name for the language
  localePath: string; // name to the locale to load namespaces from
  languageCode: string; // extended Iso15897 locale + region code (e.g. en-US)
  isDefault?: boolean;
};

const defaultLanguage: i18nLanguage = {
  name: 'English',
  localePath: 'en',
  languageCode: 'en-US',
  isDefault: true,
};

export const languages: i18nLanguage[] = [
  defaultLanguage,
  {
    name: 'English (UK)',
    localePath: 'en-GB',
    languageCode: 'en-GB',
  },
  {
    name: 'English (AU)',
    localePath: 'en-AU',
    languageCode: 'en-AU',
  },
  {
    name: 'Deutsch',
    localePath: 'de',
    languageCode: 'de-DE',
  },
  {
    name: 'Español',
    localePath: 'es',
    languageCode: 'es-ES',
  },
  {
    name: 'Français',
    localePath: 'fr',
    languageCode: 'fr-FR',
  },
  {
    name: 'Italiano',
    localePath: 'it',
    languageCode: 'it-IT',
  },
  {
    name: '日本語',
    localePath: 'ja',
    languageCode: 'ja-JP',
  },
];
export const localePaths = languages.map((lang) => lang.localePath);

const languagesByLocale = new Map(languages.map((lang) => [lang.localePath, lang]));

// __BUILD_LOCALE__ defined when running in a Gatsby build and is used to create per-language builds
// When building static sites for specific locales, this ensures the correct language is used as the primary language
export const BUILD_LANGUAGE = typeof __BUILD_LOCALE__ !== 'undefined' ? languagesByLocale.get(__BUILD_LOCALE__)?.languageCode : undefined;

export const DEFAULT_LANGUAGE = defaultLanguage.languageCode;
export const FALLBACK_LANGUAGE = BUILD_LANGUAGE ?? DEFAULT_LANGUAGE;
